module.exports = __webpack_public_path__ + "img/info.483aa1b0.svg";